
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import VueUploadComponent from 'vue-upload-component'
export default {
components: {
Grid,
GridItem,
Previewer,
FileUpload: VueUploadComponent
},
data() {
return {
files: [],
imgUploadItem: [], //TODO:和预览view数据一致，会被修改属性，会报错不影响，待优化处理
}
},
methods: {
inputFile: function(newFile, oldFile) {
if (newFile && oldFile && !newFile.active && oldFile.active) {

console.log('response', newFile.response)
if (newFile.xhr) {

console.log('status', newFile.xhr.status)
}
}
},
inputFilter: function(newFile, oldFile, prevent) {
if (newFile && !oldFile) {

if (!/\.(jpeg|jpe|jpg|gif|png|webp)$/i.test(newFile.name)) {
return prevent()
}
}


newFile.blob = ''
let URL = window.URL || window.webkitURL
if (URL && URL.createObjectURL) {
newFile.blob = URL.createObjectURL(newFile.file)

this.imgUploadItem.push({
src: newFile.blob,
index: this.imgUploadItem.length + 1
});
}
},

previewImage(index) {
this.$refs.previewer.show(index)
},

deleteImgHandle(item) {
this.imgUploadItem = this.imgUploadItem.filter(function(tmp) {
return tmp.index != item.index
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/design/components/control/sy-fileupload.vue